// extracted by mini-css-extract-plugin
module.exports = {"card":"AnnouncementsSection5_card__4IdZ2","title":"AnnouncementsSection5_title__jXgLf"};